import * as Immutable from 'immutable';
import {
  GET_SALTUSOWNERS_REQUESTED,
  GET_SALTUSOWNERS_COMPLETED,
  GET_SALTUSOWNERS_FAILED,
  RESET_SALTUSOWNERS_REQUESTED,
  RESET_SALTUSOWNERS_COMPLETED,
} from '../../actions/saltusowners/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: {},
  resettingdata: false,
  gettingdata: false,
  gotdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SALTUSOWNERS_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case GET_SALTUSOWNERS_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_SALTUSOWNERS_FAILED:
      return state.set('error', action.payload);

    case RESET_SALTUSOWNERS_REQUESTED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('resettingdata', true)
        .set('gotdata', true);

    case RESET_SALTUSOWNERS_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('resettingdata', false)
        .set('data', {})
        .set('gotdata', true);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
